import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "@/app/hooks";
import { useToast } from "@/components/ui/use-toast";
import { fetchProductStoreProduct } from "../api/fetchProductStoreProduct";
import { ProductStoreProduct } from "../api/fetchProductStoreProducts/types";
import { addToCartAction } from "../slices/productStoreCartSlice";

export function useProductDetailPage() {
  const { id } = useParams<{ id: string }>();
  const [product, setProduct] = useState<ProductStoreProduct | null>(null);
  const [loading, setLoading] = useState(true);
  const [addingToCart, setAddingToCart] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    fetchProductStoreProduct(id)
      .then((response) => {
        setProduct(response.data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  const handleBuyNow = useCallback(async () => {
    if (!product) return;
    setAddingToCart(true);
    try {
      await dispatch(addToCartAction(product, 1));
      navigate("/product-directory/checkout");
    } finally {
      setAddingToCart(false);
    }
  }, [dispatch, navigate, product]);

  const handleAddToCart = useCallback(async () => {
    if (!product) return;
    setAddingToCart(true);
    try {
      await dispatch(addToCartAction(product, 1));
      toast({
        title: "Added to Cart",
        description: `${product.name} has been added to your cart.`,
      });
    } finally {
      setAddingToCart(false);
    }
  }, [dispatch, product, toast]);

  return {
    product,
    loading,
    addingToCart,
    handleBuyNow,
    handleAddToCart,
  };
}
